import styles from './StatusDot.module.css';

type StatusDotState = 'ok' | 'warn' | 'crit' | 'off';

export interface StatusDotProps {
  state: StatusDotState;
  pulse?: boolean;
  label?: string;
}

/**
 * MCUI StatusDot — mirror from broadcast-frontend atoms.
 * Inline semantic state indicator. Optional pulsing animation
 * for active states (e.g., ON AIR, running).
 */
export function StatusDot({ state, pulse = false, label }: StatusDotProps) {
  return (
    <span
      className={`${styles.root} ${styles[`state-${state}`]} ${pulse ? styles.pulse : ''}`}
      role="status"
      aria-label={label ?? state}
    />
  );
}
